import { Currency, TravelAgentCategory, TravelAgentStatus } from "@daytrip/legacy-enums";
import { Exclude, Expose, Transform } from "class-transformer";
import { IsBoolean, IsDate, IsDefined, IsEnum, IsInt, IsNumber, IsString, Max, Min } from "class-validator";

import { GField, GObjectType } from "../graphql";
import { CDColumn, CDCreateDateColumn } from "../orm";
import { statusGetter } from "../statusGetter";
import { TransformToDate } from "../transformers/transformToDate";

@Exclude()
@GObjectType("TravelAgent")
export class TravelAgent {
    @CDColumn()
    @IsEnum(TravelAgentCategory)
    @IsString()
    @IsDefined()
    @Expose()
    @GField(() => TravelAgentCategory)
    public category: TravelAgentCategory = TravelAgentCategory.DITA;

    @CDColumn()
    @IsNumber()
    @IsDefined()
    @Expose()
    @GField(() => Currency)
    public currency: Currency = Currency.Dollar;

    @CDColumn()
    @IsNumber()
    @IsDefined()
    @Expose()
    @GField()
    public discountCoefficient: number;

    @CDColumn()
    @IsInt()
    @Min(0)
    @Max(100)
    @IsDefined()
    @Expose()
    @GField()
    public commissionPercentage: number = 0;

    @CDColumn()
    @IsDate()
    @Expose()
    @TransformToDate
    public approvedAt?: Date;

    @CDCreateDateColumn()
    @IsDate()
    @IsDefined()
    @Expose()
    @TransformToDate
    public createdAt: Date = new Date();

    @CDColumn()
    @IsDate()
    @Expose()
    @TransformToDate
    public declinedAt?: Date;

    @CDColumn()
    @IsString()
    @Expose()
    @Transform((value) => (!value ? undefined : value))
    public declinationReason?: string;

    @CDColumn()
    @IsString()
    @IsDefined()
    @Expose()
    @GField()
    public agentId: string;

    @CDColumn()
    @IsString()
    @Expose()
    @GField({ nullable: true })
    public hostAgencyId?: string;

    @CDColumn()
    @IsBoolean()
    @Expose()
    @GField()
    public partnerBookingAvailable?: boolean = false;

    @CDColumn()
    @IsString()
    @Expose()
    @Transform((value) => (!value ? undefined : value))
    public ownerId?: string;

    @CDColumn()
    @IsDefined()
    @Expose()
    public tags: Array<string> = [];

    public get status(): TravelAgentStatus {
        return statusGetter(this, TravelAgent, TravelAgentStatus);
    }

    public static statusPrototype(status: TravelAgentStatus): TravelAgent {
        const defined = new Date();

        switch (status) {
            case TravelAgentStatus.Declined:
                return {
                    declinedAt: defined,
                } as TravelAgent;

            case TravelAgentStatus.Approved:
                return {
                    declinedAt: undefined,
                    approvedAt: defined,
                } as TravelAgent;

            case TravelAgentStatus.Pending:
            default:
                return {
                    declinedAt: undefined,
                    approvedAt: undefined,
                } as TravelAgent;
        }
    }
}
